import React, { useState, useEffect } from "react";
import PageGuide from "../../components/PageGuide";
import { Helmet } from "react-helmet-async";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import {
  Card,
  Stack,
  Paper,
  Button,
  Box,
  IconButton,
  Dialog,
  TableRow,
  MenuItem,
  Chip,
  Grid,
  TableBody,
  TextField,
  Container,
  TableCell,
  Typography,
  Breadcrumbs,
  DialogTitle,
  DialogContent,
  DialogActions,
  TableContainer,
  TablePagination,
  Autocomplete,
} from "@mui/material";
import { HomeRounded } from "@mui/icons-material";
import Iconify from "../../components/iconify";
import ApiCall from "../../utils/apicall";
import Scrollbar from "../../components/scrollbar";
import { UserListHead } from "../../sections/@dashboard/user";
import { deleteContact, getContacts } from "../../feature/ContactSlice";
import { hasPermission, PERMISSIONS } from "../../utils/hasPermission";
import { validateContactForm } from "../../utils/ContactFormValidation";
import ContactImportDialog from "../../components/contacts/ContactImportDialog";
import { BrandedDialogHeader, SectionHeader, FIELD_SX } from "../../components/WeldAssure/BrandedForm";

import SmartTable from "../../components/SmartTable/SmartTable";
const TABLE_HEAD = [
  { id: "firstName", label: "First Name", alignRight: false },
  { id: "lastName", label: "Last Name", alignRight: false },
  { id: "email", label: "Email", alignRight: false },
  { id: "phoneNumber", label: "Phone Number", alignRight: false },
  { id: "company", label: "Company", alignRight: false },
  { id: "title", label: "Title", alignRight: false },
  { id: "contact_type", label: "Type", alignRight: false },
  { id: "Actions", label: "", alignRight: false },
];

const CONTACT_TYPE_LABEL = { CUSTOMER: "Customer", VENDOR: "Vendor", INSPECTOR: "Inspector", INTERNAL: "Internal", OTHER: "Other" };
const CONTACT_TYPE_COLOR = { CUSTOMER: "#1E8AA8", VENDOR: "#B5701A", INSPECTOR: "#2E9E5B", INTERNAL: "#5B6470", OTHER: "#8A6FB0" };
const CONTACT_TYPES = ["CUSTOMER", "VENDOR", "INSPECTOR", "INTERNAL", "OTHER"];
const RELATIONSHIP_TYPES = ["Manager", "Reports To", "Assistant", "Colleague", "Primary Contact", "Customer Rep", "Vendor Rep", "Spouse", "Other"];

function ContactRelationships({ value, onChange }) {
  const rels = Array.isArray(value) ? value : [];
  const set = (i, patch) => onChange(rels.map((r, idx) => (idx === i ? { ...r, ...patch } : r)));
  return (
    <Box>
      {rels.map((r, i) => (
        <Stack key={i} direction={{ xs: "column", sm: "row" }} spacing={1} sx={{ mb: 1 }} alignItems="center">
          <TextField select size="small" label="Relationship" sx={{ ...FIELD_SX, minWidth: 170 }} value={r.type || ""} onChange={(e) => set(i, { type: e.target.value })}>
            <MenuItem value="">&mdash; Type &mdash;</MenuItem>
            {RELATIONSHIP_TYPES.map((t) => (<MenuItem key={t} value={t}>{t}</MenuItem>))}
          </TextField>
          <TextField size="small" fullWidth label="Related person" sx={FIELD_SX} value={r.name || ""} onChange={(e) => set(i, { name: e.target.value })} />
          <IconButton size="small" color="error" onClick={() => onChange(rels.filter((_, idx) => idx !== i))}><Iconify icon="eva:close-fill" /></IconButton>
        </Stack>
      ))}
      <Button size="small" startIcon={<Iconify icon="eva:plus-fill" />} onClick={() => onChange([...rels, { type: "", name: "" }])} sx={{ mt: 0.5 }}>Add relationship</Button>
    </Box>
  );
}

export default function Contacts() {
  const dispatch = useDispatch();
  const [page, setPage] = useState(0);
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState("");
  const [selected, setSelected] = useState([]);
  const [filterName, setFilterName] = useState("");
  const [formErrors, setFormErrors] = useState({});
  const [selectedRow, setSelectedRow] = useState();
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [searchResults, setSearchResults] = useState([]);
  const [openUpdateModel, setOpenUpdateModel] = useState(false);
  const { loginUser } = useSelector((state) => state.userSlice);
  const { permissions: userPermissions } = loginUser.decodedToken;
  const canAddContact = hasPermission(userPermissions, PERMISSIONS.ADD_CONTACT);
  const canEditContact = hasPermission(
    userPermissions,
    PERMISSIONS.EDIT_CONTACT
  );
  const canDeleteContact = hasPermission(
    userPermissions,
    PERMISSIONS.DELETE_CONTACT
  );
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [selectedContactId, setSelectedContactId] = useState(null);
  const [openImportDialog, setOpenImportDialog] = useState(false);

  const contacts = useSelector((state) => state.ContactSlice.contacts);
  const [companies, setCompanies] = useState([]);

  useEffect(() => {
    ApiCall.get("/company").then((res) => {
      setCompanies(res.data?.data?.companies || []);
    }).catch(() => {});
  }, []);

  const fetchContacts = async () => {
    try {
      const response = await ApiCall.get("/contact");
      dispatch(getContacts(response.data.data.contacts));
      setSearchResults(response.data.data.contacts);
    } catch (error) {
      // Handle error
    }
  };
  useEffect(() => {
    const fetchContactss = async () => {
      try {
        const response = await ApiCall.get("/contact");
        dispatch(getContacts(response.data.data.contacts));
        setSearchResults(response.data.data.contacts);
      } catch (error) {
        // Handle error
      }
    };
    fetchContactss();
  }, [dispatch]);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };
  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = contacts.map((n) => n.name);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setPage(0);
    setRowsPerPage(parseInt(event.target.value, 10));
  };

  const handleDelete = async (id) => {
    var data = dispatch(deleteContact(id));
    if (data) {
      toast("Contact Deleted Successfully!");

      fetchContacts();
    }
  };
  const handleDeletedialog = (id) => {
    setSelectedContactId(id);
    setOpenDeleteDialog(true);
  };

  const handleFilterByName = (event) => {
    setPage(0);
    setFilterName(event.target.value);
    if (event.key === "Enter") {
      event.preventDefault();
      handleSearch();
    }
  };

  const handleEnterKeyPress = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      handleSearch();
    }
  };

  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - searchResults.length) : 0;
  const isNotFound = !searchResults.length && !!filterName;
  const [open, setOpen] = useState(false);

  const initialNewContact = {
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    title: "",
    address: "",
    company_id: null,
    contact_type: "",
    email_personal: "",
    office_phone: "",
    address_line2: "",
    city: "",
    state: "",
    postal_code: "",
    country: "",
    relationships: [],
  };
  const [newContact, setNewContact] = useState({ ...initialNewContact });

  const ContactForm = ({ data, set }) => (
    <Grid container spacing={1.5}>
      <Grid item xs={12}><SectionHeader>Name &amp; Role</SectionHeader></Grid>
      <Grid item xs={12} sm={6}><TextField label="First Name" fullWidth size="small" sx={FIELD_SX} value={data.firstName || ""} onChange={(e) => set({ firstName: e.target.value })} error={formErrors.firstName !== undefined} helperText={formErrors.firstName} /></Grid>
      <Grid item xs={12} sm={6}><TextField label="Last Name" fullWidth size="small" sx={FIELD_SX} value={data.lastName || ""} onChange={(e) => set({ lastName: e.target.value })} error={formErrors.lastName !== undefined} helperText={formErrors.lastName} /></Grid>
      <Grid item xs={12} sm={6}><TextField label="Title / Role" fullWidth size="small" sx={FIELD_SX} value={data.title || ""} onChange={(e) => set({ title: e.target.value })} /></Grid>
      <Grid item xs={12} sm={6}><TextField select fullWidth size="small" sx={FIELD_SX} label="Contact Type" value={data.contact_type || ""} onChange={(e) => set({ contact_type: e.target.value })}><MenuItem value="">&mdash; None &mdash;</MenuItem>{CONTACT_TYPES.map((t) => (<MenuItem key={t} value={t}>{CONTACT_TYPE_LABEL[t]}</MenuItem>))}</TextField></Grid>

      <Grid item xs={12}><SectionHeader>Phone</SectionHeader></Grid>
      <Grid item xs={12} sm={6}><TextField label="Office Phone" fullWidth size="small" sx={FIELD_SX} value={data.office_phone || ""} onChange={(e) => set({ office_phone: e.target.value })} /></Grid>
      <Grid item xs={12} sm={6}><TextField label="Mobile / Private" fullWidth size="small" sx={FIELD_SX} value={data.phoneNumber || ""} onChange={(e) => set({ phoneNumber: e.target.value })} error={formErrors.phoneNumber !== undefined} helperText={formErrors.phoneNumber} /></Grid>

      <Grid item xs={12}><SectionHeader>Email</SectionHeader></Grid>
      <Grid item xs={12} sm={6}><TextField label="Work Email" fullWidth size="small" sx={FIELD_SX} value={data.email || ""} onChange={(e) => set({ email: e.target.value })} error={formErrors.email !== undefined} helperText={formErrors.email} /></Grid>
      <Grid item xs={12} sm={6}><TextField label="Personal Email" fullWidth size="small" sx={FIELD_SX} value={data.email_personal || ""} onChange={(e) => set({ email_personal: e.target.value })} /></Grid>

      <Grid item xs={12}><SectionHeader>Address</SectionHeader></Grid>
      <Grid item xs={12} sm={8}><TextField label="Street" fullWidth size="small" sx={FIELD_SX} value={data.address || ""} onChange={(e) => set({ address: e.target.value })} /></Grid>
      <Grid item xs={12} sm={4}><TextField label="Suite / Unit" fullWidth size="small" sx={FIELD_SX} value={data.address_line2 || ""} onChange={(e) => set({ address_line2: e.target.value })} /></Grid>
      <Grid item xs={12} sm={5}><TextField label="City" fullWidth size="small" sx={FIELD_SX} value={data.city || ""} onChange={(e) => set({ city: e.target.value })} /></Grid>
      <Grid item xs={6} sm={3}><TextField label="State" fullWidth size="small" sx={FIELD_SX} value={data.state || ""} onChange={(e) => set({ state: e.target.value })} /></Grid>
      <Grid item xs={6} sm={4}><TextField label="ZIP / Postal" fullWidth size="small" sx={FIELD_SX} value={data.postal_code || ""} onChange={(e) => set({ postal_code: e.target.value })} /></Grid>
      <Grid item xs={12} sm={6}><TextField label="Country" fullWidth size="small" sx={FIELD_SX} value={data.country || ""} onChange={(e) => set({ country: e.target.value })} /></Grid>

      <Grid item xs={12}><SectionHeader>Company &amp; Relationships</SectionHeader></Grid>
      <Grid item xs={12}><Autocomplete options={companies} getOptionLabel={(o) => o.name || ""} value={companies.find((c) => c.id === data.company_id) || null} onChange={(_, val) => set({ company_id: val ? val.id : null })} renderInput={(params) => (<TextField {...params} label="Company" fullWidth size="small" sx={FIELD_SX} />)} /></Grid>
      <Grid item xs={12}><ContactRelationships value={data.relationships} onChange={(rels) => set({ relationships: rels })} /></Grid>
    </Grid>
  );

  const handleCreateContact = async (e) => {
    const values = validateContactForm(newContact);

    setFormErrors(values);
    if (Object.keys(values).length === 0) {
      try {
        const newContactData = {
          firstName: newContact.firstName,
          lastName: newContact.lastName,
          email: newContact.email,
          phoneNumber: newContact.phoneNumber,
          title: newContact.title || null,
          address: newContact.address || null,
          company_id: newContact.company_id || null,
          contact_type: newContact.contact_type || null,
          email_personal: newContact.email_personal || null,
          office_phone: newContact.office_phone || null,
          address_line2: newContact.address_line2 || null,
          city: newContact.city || null,
          state: newContact.state || null,
          postal_code: newContact.postal_code || null,
          country: newContact.country || null,
          relationships: newContact.relationships || [],
        };

        const response = await ApiCall.post("/contact", newContactData);

        if (response.status === 201) {
          setFormErrors("");
          handleClose();
          toast("Contact Added Successfully!");

          fetchContacts();
          setNewContact({ ...initialNewContact });
        } else {
        }
      } catch (error) {}
    }
  };

  const handleUpdateContact = async () => {
    const values = validateContactForm(selectedRow);

    setFormErrors(values);
    if (Object.keys(values).length === 0) {
      try {
        const response = await ApiCall.put(
          `contact/${selectedRow.id}`,
          selectedRow
        );

        if (response.status === 200) {
          handleClose();
          toast("Contact Updated Successfully!");

          fetchContacts();
          setOpenUpdateModel(false);
        } else {
        }
      } catch (error) {}
    }
  };

  const handleOpenModel = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setFormErrors("");
    setNewContact({ ...initialNewContact });
    setOpenUpdateModel(false);
    setOpen(false);
  };

  const handleSearch = async () => {
    try {
      const response = await ApiCall.get("/contact", {
        params: {
          firstName: filterName,
        },
      });
      setSearchResults(response.data.data.contacts);
    } catch (error) {}
  };
  useEffect(() => {
    const handleSearchs = async () => {
      try {
        const response = await ApiCall.get("/contact", {
          params: {
            firstName: filterName,
          },
        });
        setSearchResults(response.data.data.contacts);
      } catch (error) {}
    };
    handleSearchs();
  }, [filterName]);

  // Utility function to format phone number as (123) 456-7890
  function formatPhoneNumber(phoneNumberString) {
    var cleaned = ("" + phoneNumberString).replace(/\D/g, "");
    var match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
    if (match) {
      var intlCode = "+1 ";
      return [intlCode, "(", match[2], ") ", match[3], "-", match[4]].join("");
    }
    return null;
  }

  return (
    <>
      <Helmet>
        <title>Contacts | SFM</title>
      </Helmet>
      <div className="container">
        <Container>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            mb={5}
          >
            <Breadcrumbs aria-label="breadcrumb">
              <Stack direction="row" alignItems="center" spacing={1}>
                <HomeRounded color="inherit" />
                <Typography variant="body1" color="textPrimary">
                  / Contacts
                </Typography>
              </Stack>
            </Breadcrumbs>

            <Stack direction="row" spacing={1.5}>
              {canAddContact && (
                // W-26 (2026-10-06): the server's contact import route is switched off, so every import
                // failed. The button stays visible but disabled, with the reason, until the route returns.
                <Stack alignItems="flex-end" spacing={0.25}>
                  <Button
                    disabled
                    variant="outlined"
                    startIcon={<Iconify icon="eva:upload-fill" />}
                  >
                    Import
                  </Button>
                  <Typography variant="caption" color="text.secondary">
                    Import is not available yet. Add contacts with New Contact.
                  </Typography>
                </Stack>
              )}
              {canAddContact && (
                <Button
                  onClick={handleOpenModel}
                  variant="contained"
                  startIcon={<Iconify icon="eva:plus-fill" />}
                >
                  New Contact
                </Button>
              )}
            </Stack>
            {openUpdateModel && (
              <Dialog open={openUpdateModel} onClose={handleClose} maxWidth="sm" fullWidth PaperProps={{ sx: { borderRadius: 3, overflow: "hidden" } }}>
                <BrandedDialogHeader title="Edit Contact" subtitle="Contacts · SFM" onClose={handleClose} />
                <DialogContent sx={{ pt: 2.5 }}>
                  <ContactForm data={selectedRow} set={(patch) => setSelectedRow({ ...selectedRow, ...patch })} />
                </DialogContent>
                <DialogActions sx={{ bgcolor: "#F7F9FC", borderTop: "1px solid #E8ECF0", px: 3, py: 1.75 }}>
                  <Button onClick={handleClose} sx={{ color: "text.secondary" }}>Cancel</Button>
                  <Button variant="contained" onClick={handleUpdateContact}>Update</Button>
                </DialogActions>
              </Dialog>
            )}

            <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth PaperProps={{ sx: { borderRadius: 3, overflow: "hidden" } }}>
              <BrandedDialogHeader title="Add New Contact" subtitle="Contacts · SFM" onClose={handleClose} />
              <DialogContent sx={{ pt: 2.5 }}>
                <ContactForm data={newContact} set={(patch) => setNewContact({ ...newContact, ...patch })} />
              </DialogContent>
                <DialogActions sx={{ bgcolor: "#F7F9FC", borderTop: "1px solid #E8ECF0", px: 3, py: 1.75 }}>
                  <Button onClick={handleClose} sx={{ color: "text.secondary" }}>Cancel</Button>
                  <Button variant="contained" onClick={handleCreateContact}>Create</Button>
                </DialogActions>
            </Dialog>
          </Stack>

          <Typography variant="h4" sx={{ fontWeight: 600, mb: 1 }}>Contacts</Typography>
          <PageGuide
            why="Keep one clean directory of the people you work with — so the right contact is always at hand."
            who="Anyone who needs the right person's details — sales, PM, purchasing, admin."
            what="Your contact directory: names, roles, phones, emails, addresses, and relationships."
            how="Add a contact with their details and link them to a company or related people."
            when="Whenever you start working with a new person on a job or with a vendor."
            standard="ISO 9001:2015 §7.5"
          />

          <Card>
            <div
              style={{
                display: "flex",
                width: "100%",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <TextField
                label="Search Contact.."
                variant="outlined"
                margin="normal"
                value={filterName}
                onChange={handleFilterByName}
                onKeyDown={handleEnterKeyPress}
              />

              <TablePagination
                rowsPerPageOptions={[10, 25]}
                component="div"
                count={searchResults.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </div>

            <Scrollbar>
              <TableContainer sx={{ minWidth: 800 }}>
                <SmartTable tableId="contacts" lockedColumns={["First Name", "Last Name"]}>
                  <UserListHead
                    orderBy={orderBy}
                    headLabel={TABLE_HEAD}
                    rowCount={contacts.length}
                    numSelected={selected.length}
                    onRequestSort={handleRequestSort}
                    onSelectAllClick={handleSelectAllClick}
                  />
                  <TableBody>
                    {searchResults
                      .slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage
                      )
                      .map((contact) => {
                        const { id, firstName, lastName, email, phoneNumber, company_id, title, contact_type } =
                          contact;
                        return (
                          <TableRow hover key={id} tabIndex={-1}>
                            <TableCell component="th" scope="row" padding="100">
                              {firstName}
                            </TableCell>
                            <TableCell align="left">{lastName}</TableCell>
                            <TableCell align="left">{email}</TableCell>
                            <TableCell align="left">
                              {formatPhoneNumber(phoneNumber)}
                            </TableCell>
                            <TableCell align="left">{(companies.find((c) => c.id === company_id) || {}).name || "\u2014"}</TableCell>
                            <TableCell align="left">{title || "\u2014"}</TableCell>
                            <TableCell align="left">{contact_type ? (<Chip size="small" label={CONTACT_TYPE_LABEL[contact_type] || contact_type} sx={{ bgcolor: CONTACT_TYPE_COLOR[contact_type] || "#5B6470", color: "#fff", fontWeight: 600 }} />) : (<span style={{ color: "#9aa3ad" }}>\u2014</span>)}</TableCell>
                            <TableCell
                              align="right"
                              style={{ display: "flex" }}
                            >
                              {canEditContact && (
                                <MenuItem
                                  onClick={() => {
                                    setSelectedRow(contact);
                                    setOpenUpdateModel(!openUpdateModel);
                                  }}
                                >
                                  <Iconify icon={"eva:edit-fill"} />
                                </MenuItem>
                              )}
                              {canDeleteContact && (
                                <MenuItem
                                  sx={{ color: "error.main" }}
                                  onClick={() => handleDeletedialog(id)}
                                >
                                  <Iconify icon={"eva:trash-2-outline"} />
                                </MenuItem>
                              )}
                            </TableCell>
                            <Dialog
                              open={openDeleteDialog}
                              onClose={() => setOpenDeleteDialog(false)}
                            >
                              <DialogTitle>Delete Contact</DialogTitle>
                              <DialogContent>
                                <Typography>
                                  Are you sure you want to delete this contact?
                                </Typography>
                              </DialogContent>
                              <DialogActions>
                                <Button
                                  onClick={() => setOpenDeleteDialog(false)}
                                >
                                  Cancel
                                </Button>
                                <Button
                                  onClick={() => {
                                    handleDelete(selectedContactId);
                                    setOpenDeleteDialog(false);
                                  }}
                                  color="primary"
                                >
                                  Delete
                                </Button>
                              </DialogActions>
                            </Dialog>
                          </TableRow>
                        );
                      })}
                    {emptyRows > 0 && (
                      <TableRow style={{ height: 53 * emptyRows }}>
                        <TableCell colSpan={4} />
                      </TableRow>
                    )}
                  </TableBody>

                  {isNotFound && (
                    <TableBody>
                      <TableRow>
                        <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                          <Paper
                            sx={{
                              textAlign: "center",
                            }}
                          >
                            <Typography variant="h6" paragraph>
                              Not found
                            </Typography>

                            <Typography variant="body2">
                              No results found for &nbsp;
                              <strong>&quot;{filterName}&quot;</strong>.
                              <br /> Try checking for typos or using complete
                              words.
                            </Typography>
                          </Paper>
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  )}
                </SmartTable>
              </TableContainer>
            </Scrollbar>

            <TablePagination
              rowsPerPageOptions={[10, 25]}
              component="div"
              count={searchResults.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </Card>
        </Container>
      </div>

      {/* Contact import dialog */}
      <ContactImportDialog
        open={openImportDialog}
        onClose={() => setOpenImportDialog(false)}
        onSuccess={(count) => {
          setOpenImportDialog(false);
          toast(`${count} contact${count !== 1 ? "s" : ""} imported successfully!`);
          fetchContacts();
        }}
      />
    </>
  );
}

